import { create } from 'zustand'
import { auditLogApi, AuditLogEntry } from '@/lib/api'

interface AuditLogStore {
  entries: AuditLogEntry[]
  loading: boolean
  error: string | null

  fetchEntries: (params?: { limit?: number; skip?: number }) => Promise<void>
  reset: () => void
}

const initialState = {
  entries: [],
  loading: false,
  error: null,
}

export const useAuditLogStore = create<AuditLogStore>((set) => ({
  ...initialState,

  fetchEntries: async (params) => {
    set({ loading: true, error: null })
    try {
      const response = await auditLogApi.list(params)
      set({ entries: response.data, loading: false })
    } catch (error: any) {
      set({ error: error.response?.data?.detail || 'Failed to load audit log', loading: false })
      throw error
    }
  },

  reset: () => set(initialState),
}))
